var map = {
	"./categories.json": 2695,
	"./charts.json": 1564,
	"./dashboard.json": 4933,
	"./forgot_password.json": 6752,
	"./home.json": 2003,
	"./inventoryItems.json": 3464,
	"./login.json": 1194,
	"./menu.json": 5488,
	"./messages.json": 7564,
	"./popup.json": 3878,
	"./popups.json": 8198,
	"./pos.json": 1298,
	"./pos_hub.json": 4426,
	"./pos_kitchen.json": 4703,
	"./pos_stations.json": 6290,
	"./products.json": 5998,
	"./purchases.json": 8869,
	"./raw_products.json": 3433,
	"./reset_password.json": 3284,
	"./sale_order_details.json": 6852,
	"./sale_orders.json": 2861,
	"./signup.json": 9988,
	"./tables.json": 8414,
	"./topics.json": 6272,
	"./userList.json": 4566
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7308;